/*
  WHAT'S IN IT / PER SCOOP DEETS tabs for the homepage card layout of the
  PDP buy box (6.14.5). The section renders the tabs twice (mobile and
  desktop copies); every action here applies to BOTH copies inside the same
  buy box root so a resize across 990 never shows a different tab.

  PER SERVING: recomputed on every ero:buybox:change (flavor or plan swap)
  from the event's price (cents) and the product's servings in the buy box
  JSON catalog, so it always matches the selected plan card.
*/
(function () {
  'use strict';

  var roots = new Map();

  function parseCatalog(root) {
    var node = root.querySelector('[data-ero-pdp-products]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function initRoot(root) {
    if (!root || roots.has(root)) return;
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-bb-tabs]'));
    if (!groups.length) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var catalog = parseCatalog(root);

    function setAccent(key) {
      root.setAttribute('data-bb-accent', key === 'pm' || key === 'bundle' ? key : 'br');
    }
    setAccent(root.dataset.initialFlavor);

    function select(key) {
      groups.forEach(function (group) {
        group.querySelectorAll('[data-bb-tab]').forEach(function (tab) {
          var on = tab.getAttribute('data-bb-tab') === key;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
        group.querySelectorAll('[data-bb-tab-panel]').forEach(function (panel) {
          var on = panel.getAttribute('data-bb-tab-panel') === key;
          panel.classList.toggle('is-active', on);
          panel.hidden = !on;
        });
      });
    }

    groups.forEach(function (group) {
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-bb-tab]'));
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          select(tab.getAttribute('data-bb-tab'));
        }, { signal: signal });
        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          var step = event.key === 'ArrowRight' ? 1 : -1;
          var next = tabs[(index + step + tabs.length) % tabs.length];
          select(next.getAttribute('data-bb-tab'));
          next.focus();
        }, { signal: signal });
      });
    });

    document.addEventListener('ero:buybox:change', function (event) {
      var detail = event.detail || {};
      setAccent(detail.key);
      if (!catalog || !catalog.products) return;
      var product = catalog.products[detail.key];
      var servings = product ? Number(product.servings || 0) : 0;
      if (servings <= 0) return;
      var text = '$' + (Number(detail.price || 0) / servings / 100).toFixed(2);
      root.querySelectorAll('[data-bb-stat-per-serving]').forEach(function (node) {
        node.textContent = text;
      });
    }, { signal: signal });

    roots.set(root, controller);
  }

  function destroyRoot(root) {
    var controller = roots.get(root);
    if (controller) controller.abort();
    roots.delete(root);
  }

  function initAll(context) {
    if (context.matches && context.matches('[data-ero-pdp-buy-box]')) initRoot(context);
    context.querySelectorAll('[data-ero-pdp-buy-box]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-ero-pdp-buy-box]')
      ? event.target
      : event.target.querySelector('[data-ero-pdp-buy-box]');
    if (root) destroyRoot(root);
  });
})();
